import { gql } from "@apollo/client";

export const UPDATE_DOC_PUBLIC = gql`
	mutation UpdateDocumentPUBLIC($id: String!) {
		updateDocumentPublic(id: $id)
	}
`;
